import React from 'react';
import { Icon } from 'components/semantic';
import styles from './index.module.scss';

export interface ImageFile {
  name?: string;
  url: string;
}

interface ImageThumbGridProps {
  images: ImageFile[];
  size?: string;
  onDelete?: (url: string) => void;
}

const ImageThumbGrid = ({ images, onDelete, size = '100px' }: ImageThumbGridProps) => {
  images = images || [];
  return (
    <div className={styles.imgThumbGrid}>
      {images.map((item) => (
        <div key={item.url}>
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            <img src={item.url} alt={item.name} width={size} height={size} className={styles.img} />
          </a>
          {onDelete && (
            <a
              href="#a"
              onClick={(e) => {
                e.preventDefault();
                onDelete(item.url);
              }}
            >
              <Icon name="trash alternate" />
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default ImageThumbGrid;
